export default "__VITE_ASSET__BxZPTOjc__"